function addressesSelector(state) {
  return state.user.address;
}

function getTokenSelector(state) {
  return state.user.token;
}

function ordersSelector(state) {
  return state.user.orders;
}

function ordersNeedsActionSelector(state) {
  return state.user.orders_needs_action;
}
function transactionsSelector(state) {
  return state.user.transactions;
}
function profileSelector(state) {
  return state.user.profile;
}

function groupsSelector(state) {
  return state.user.groups;
}

function selectedGroupSelector(state) {
  return state.user.selectedGroup;
}

function remainingPayableOrdersSelector(state) {
  let orders: any[] = ordersSelector(state) || [];
  let readyForDelivers = orders.filter((order) =>
    ["work_done", "delivery_canceled", "delivery_not_present"].includes(
      order.latest_status
    )
  );

  let payable = readyForDelivers.reduce((previousValue, order) => {
    return previousValue + order.price_descriptor.total_price;
  }, 0);

  return {
    orders: readyForDelivers,
    payable,
  };
}

function hasBasicProfileSelector(state) {
  let profile = profileSelector(state);

  if (!profile) return false;

  let { first_name, last_name } = profile;

  return !!first_name && !!last_name;
}

export {
  addressesSelector,
  getTokenSelector,
  ordersSelector,
  ordersNeedsActionSelector,
  profileSelector,
  groupsSelector,
  selectedGroupSelector,
  hasBasicProfileSelector,
  remainingPayableOrdersSelector,
  transactionsSelector,
};

// old
export default {
  app_data_loading: (state) => state.user.app_data_loading,
  app_data_failed: (state) => state.user.app_data_failed,
  app_data_updatedAt: (state) => state.user.app_data_updatedAt,
  user: profileSelector,
  login: (state) => state.user.login,
  getToken: getTokenSelector,
  addresses: addressesSelector,
  transactions: transactionsSelector,
  orders: ordersSelector,
};
